export default "__VITE_ASSET__RxjxsOm6__"